// src/app/modules/Members/pages/members-table/MembersTable.jsx
import React from "react";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import * as columnFormatters from "./column-formatters";

export function MembersTable({
  members,
  loading,
  onViewDetails,
  onEdit,
  onSuspend,
  onReactivate,
  onDelete,
  onResendInvite,
  onCancelInvite,
  currentPage,
  perPage,
  totalCount,
  onPageChange,
}) {
  const totalPages = Math.max(1, Math.ceil((totalCount || 0) / (perPage || 10)));
  const extra = { onViewDetails, onEdit, onSuspend, onReactivate, onDelete, onResendInvite, onCancelInvite };

  if (loading && !members.length) {
    return <div className="sety-tbl-sub" style={{ padding: 22 }}>Loading…</div>;
  }

  if (!members.length) {
    return <div className="sety-tbl-sub" style={{ padding: 22 }}>Nothing here yet.</div>;
  }

  return (
    <div>
      <div className="sety-tbl-wrap">
        <table className="sety-tbl">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Floor</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {members.map((row) => (
              <tr key={row.membership_id}>
                <td style={{ fontWeight: 600, fontSize: 14 }}>{row.name}</td>
                <td>{columnFormatters.MemberTypeColumnFormatter(row.type, row)}</td>
                <td>
                  {row.floor
                    ? <span className="sety-tbl-sub">{row.floor}</span>
                    : <span className="sety-tbl-sub">—</span>}
                </td>
                <td style={{ textAlign: 'right' }}>
                  {columnFormatters.ActionsColumnFormatter(null, row, 0, extra)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '14px 22px', borderTop: '1px solid var(--ink-100)',
        }}>
          <span className="sety-tbl-sub">Page {currentPage} of {totalPages}</span>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="sety-btn sety-btn-ghost" disabled={currentPage <= 1} onClick={() => onPageChange(currentPage - 1)}>
              <ChevronLeft size={14} />Prev
            </button>
            <button className="sety-btn sety-btn-ghost" disabled={currentPage >= totalPages} onClick={() => onPageChange(currentPage + 1)}>
              Next<ChevronRight size={14} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
